var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "32px",
    viewBox: "0 0 27 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / calendar big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R\\xE9servation-FRONT-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Serveat-r\\xE9servation-04",
    transform: "translate(-732.000000, -633.000000)",
    fill: "#E84249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inscription",
    transform: "translate(120.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "addition-login"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2\\xE8service-copy",
    transform: "translate(610.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jour",
    transform: "translate(2.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-calendar-big",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6875,6.6875 L1.6875,30.3125 L25.3125,30.3125 L25.3125,6.6875 L1.6875,6.6875 Z M1.6875,5 L25.3125,5 C26.2444805,5 27,5.75551948 27,6.6875 L27,30.3125 C27,31.2444805 26.2444805,32 25.3125,32 L1.6875,32 C0.755519485,32 1.14134695e-16,31.2444805 0,30.3125 L0,6.6875 C-1.14134695e-16,5.75551948 0.755519485,5 1.6875,5 Z",
    id: "Rectangle-2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4",
    points: "1 12 26 12 26 14 1 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4",
    points: "5 17 8 17 8 20 5 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4",
    points: "5 23 8 23 8 26 5 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4-Copy",
    points: "18 23 21 23 21 26 18 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4",
    points: "12 17 15 17 15 20 12 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L4,0 C4.55228475,-1.01453063e-16 5,0.44771525 5,1 L5,5 L2,5 L2,1 C2,0.44771525 2.44771525,1.01453063e-16 3,0 Z",
    id: "Rectangle-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L11,0 C11.5522847,-1.01453063e-16 12,0.44771525 12,1 L12,5 L9,5 L9,1 C9,0.44771525 9.44771525,1.01453063e-16 10,0 Z",
    id: "Rectangle-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L17,0 C17.5522847,-1.01453063e-16 18,0.44771525 18,1 L18,5 L15,5 L15,1 C15,0.44771525 15.4477153,1.01453063e-16 16,0 Z",
    id: "Rectangle-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,0 L24,0 C24.5522847,-1.01453063e-16 25,0.44771525 25,1 L25,5 L22,5 L22,1 C22,0.44771525 22.4477153,1.01453063e-16 23,0 Z",
    id: "Rectangle-3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBig);
export default __webpack_public_path__ + "static/media/calendar-big.8e46e1ddc608392d375aed70895c3faa.svg";
export { ForwardRef as ReactComponent };